import { Component, Input, OnInit } from '@angular/core';
import { helpUrlsLookup } from 'go-modules/help-urls/help-urls.constant';
import { ActiveBrandService } from '@go-modules/services/active-brand';

export interface DeprecatedLaunchError {
	deprecatedLaunch: string[];
}

@Component({
	selector: 'deprecated-launch-error-renderer',
	templateUrl: './deprecated-launch-error.component.html',
	styleUrls: ['./deprecated-launch-error.component.scss'],
	standalone: false
})
export class DeprecatedLaunchErrorComponent implements OnInit {
	@Input() public errors: DeprecatedLaunchError;

	public setupInstructionsLink: string;
	public contactSupport: string;

	public constructor (public activeBrandService: ActiveBrandService) {}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public ngOnInit () {
		this.setupInstructionsLink = helpUrlsLookup.deprecatedLaunch;
		this.contactSupport = helpUrlsLookup.contactSupport;
	}
}
